import { Seo } from "@/site/seo";
import { SITE } from "@/site/content";
import { Heading } from "@/site/components/Section";

const PRIVACY = (
  <div className="prose">
    <p>Last updated {SITE.lastUpdated}. This notice covers this website and the pilot-request form. Product data processing for customers is governed by the data processing agreement in your order form.</p>
    <h2>What we collect on this site</h2>
    <ul>
      <li><b>Pilot / walkthrough requests:</b> name, work email, company, team size, CRM, an optional message, and the page and campaign parameters (UTM, referrer) you arrived with. Used only to reply to you and to understand which channels bring the right teams.</li>
      <li><b>Usage events:</b> anonymous, first-party, cookie-less events (page views, calculator use, button clicks) keyed to a random per-tab identifier that is discarded when the tab closes. No cross-site tracking, no advertising identifiers.</li>
      <li><b>Server logs:</b> IP address and request metadata, retained 30 days for abuse prevention and rate limiting.</li>
    </ul>
    <h2>What we do not do</h2>
    <ul><li>No marketing lists, no resale, no third-party ad pixels. If we add an analytics vendor it will be listed here by name.</li></ul>
    <h2>Retention and your rights</h2>
    <p>Lead records are kept for 24 months or until you ask us to delete them. {SITE.email ? <>Email <a href={`mailto:${SITE.email}`}>{SITE.email}</a></> : <>Use the <a href="/contact">contact form</a></>} to access, correct or delete anything we hold about you; we act within 30 days.</p>
    <h2>Cookies</h2>
    <p>Postern sets no cookies of its own on this site. Our hosting or CDN provider may set its own cookies for security and performance (for example, bot protection) — see their policy for details. The product application sets one httpOnly session cookie required to log in.</p>
  </div>
);

const TERMS = (
  <div className="prose">
    <p>Last updated {SITE.lastUpdated}. These terms cover use of this website. Use of the Postern product is governed by the order form and master agreement signed by your company.</p>
    <h2>Website use</h2>
    <ul>
      <li>The deal calculator and demo whitespace grid are illustrative. They run the product's pricing functions against a sample catalog and fictional accounts; they are not a quote.</li>
      <li>You may not probe, scrape at volume, or attempt to disrupt the site or its API. Rate limits apply.</li>
    </ul>
    <h2>Pricing shown</h2>
    <p>Plan prices on this site are list prices in USD — $500 a month covers your first 8 seats, then $50 per additional seat, billed monthly — and may change; the price in your signed order form governs.</p>
    <h2>Contact</h2>
    <p>{SITE.email ? <a href={`mailto:${SITE.email}`}>{SITE.email}</a> : <a href="/contact">Through the contact form</a>}</p>
  </div>
);

export default function LegalPage({ kind }) {
  const isPrivacy = kind === "privacy";
  return (
    <>
      <Seo title={isPrivacy ? "Privacy" : "Terms"} description={isPrivacy ? "What Postern's website collects, why, and how to remove it." : "Terms of use for the Postern website."} />
      <section className="section">
        <div className="wrap" style={{ maxWidth: 820 }}>
          <Heading eyebrow={isPrivacy ? "Privacy" : "Terms"} title={isPrivacy ? "What this site collects, in plain language." : "Terms of use for this website."} />
          {isPrivacy ? PRIVACY : TERMS}
        </div>
      </section>
    </>
  );
}
